export const LOAD_CAMPAIGN_LINK = 'LOAD_CAMPAIGN_LINK';
export const LOAD_CAMPAIGN_LINK_ORDERS = 'LOAD_CAMPAIGN_LINK_ORDERS';
export const UPDATE_CAMPAIGN_LINK = 'UPDATE_CAMPAIGN_LINK';
